"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trim = void 0;
function trim(_a, value, length) {
    var raw = _a.raw, noTrim = _a.noTrim;
    if (noTrim || raw || value.length <= length)
        return value;
    var trimmed = value.slice(0, Math.max(length, 0));
    var dots = trimmed.length === 0 ? '' :
        trimmed.length <= 3 ? '.' :
            trimmed.length === 4 ? '..' : '...';
    return trimmed.slice(0, trimmed.length - dots.length) + dots;
}
exports.trim = trim;
//# sourceMappingURL=trim.js.map